import React, { useState } from 'react';
import './MentorsTab.css';
import MentorFeedbacksSubTab from './MentorFeedbacksSubTab';
import MentorProfilesSubTab from './MentorProfilesSubTab';
import MentorQuestionValidationsSubTab from './MentorQuestionValidationsSubTab';
import MentorValidationResultsSubTab from './MentorValidationResultsSubTab';
import MentorValidationPointsSubTab from './MentorValidationPointsSubTab';
import MentorValidationPointsHistorySubTab from './MentorValidationPointsHistorySubTab';
import MentorDirectionsSubTab from './MentorDirectionsSubTab';
import MentorPhotosSubTab from './MentorPhotosSubTab';
import MentorVerificationRequestsSubTab from './MentorVerificationRequestsSubTab';
import MentorCardInfoSubTab from './MentorCardInfoSubTab';
import MentorCardStatusesSubTab from './MentorCardStatusesSubTab';

function MentorsTab() {
  const [activeSubTab, setActiveSubTab] = useState('profiles');

  return (
    <div className="mentors-tab">
      <div className="sub-tabs">
        <button
          className={`sub-tab-button ${activeSubTab === 'profiles' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('profiles')}
        >
          Профили менторов
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'card-info' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('card-info')}
        >
          Карточки менторов
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'card-statuses' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('card-statuses')}
        >
          Статусы карточек
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'validations' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('validations')}
        >
          Валидации вопросов
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'validation-results' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('validation-results')}
        >
          Результаты валидаций
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'points' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('points')}
        >
          Очки валидации
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'points-history' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('points-history')}
        >
          История начисления очков
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'feedbacks' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('feedbacks')}
        >
          Фитбэки
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'directions' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('directions')}
        >
          Направления менторства
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'photos' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('photos')}
        >
          Фотографии менторов
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'verification-requests' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('verification-requests')}
        >
          Заявки на верификацию
        </button>
      </div>
      <div className="sub-tab-content">
        {activeSubTab === 'profiles' && <MentorProfilesSubTab />}
        {activeSubTab === 'card-info' && <MentorCardInfoSubTab />}
        {activeSubTab === 'card-statuses' && <MentorCardStatusesSubTab />}
        {activeSubTab === 'validations' && <MentorQuestionValidationsSubTab />}
        {activeSubTab === 'validation-results' && <MentorValidationResultsSubTab />}
        {activeSubTab === 'points' && <MentorValidationPointsSubTab />}
        {activeSubTab === 'points-history' && <MentorValidationPointsHistorySubTab />}
        {activeSubTab === 'feedbacks' && <MentorFeedbacksSubTab />}
        {activeSubTab === 'directions' && <MentorDirectionsSubTab />}
        {activeSubTab === 'photos' && <MentorPhotosSubTab />}
        {activeSubTab === 'verification-requests' && <MentorVerificationRequestsSubTab />}
      </div>
    </div>
  );
}

export default MentorsTab;
